import { AIServiceType } from '@/ai'
import type { LLMConnection } from '#/llm'
import { useLLMConnectionStore } from '@/stores/llmConnectionStore'

export const THESIS_CONN_ID = 'thesis-platform'
export const THESIS_MODEL_NAME =
  (import.meta.env.VITE_THESIS_MODEL as string | undefined)?.trim() || 'gpt-4o-mini'

const SUB_STORAGE_KEY = 'thesis-subscription-v3'

export function thesisApiBase(): string {
  return (import.meta.env.VITE_THESIS_API_BASE as string | undefined)?.trim().replace(/\/$/, '') || ''
}

function tokenFromStorage(): string {
  try {
    const raw = localStorage.getItem(SUB_STORAGE_KEY)
    if (!raw) return ''
    const parsed = JSON.parse(raw) as { state?: { token?: string } }
    return String(parsed?.state?.token || '').trim()
  } catch {
    return ''
  }
}

/** 有代付 API 时写入固定连接 + 模型列表；apiKey 为 JWT（未登录占位 thesis-platform） */
export function ensureThesisPlatformConnection(tokenOverride?: string) {
  const base = thesisApiBase()
  if (!base) return

  const apiKey = (tokenOverride ?? tokenFromStorage()) || 'thesis-platform'
  const store = useLLMConnectionStore.getState()
  const exists = store.connections.find((c) => c.id === THESIS_CONN_ID)
  const conn: LLMConnection = {
    id: THESIS_CONN_ID,
    name: '论文台',
    disabled: false,
    provider: AIServiceType.OpenAI,
    baseUrl: `${base}/v1`,
    apiKey,
  }

  if (!exists) store.addConnection(conn)
  else store.updateConnection(conn)

  useLLMConnectionStore.setState((s) => ({
    connectionModels: {
      ...s.connectionModels,
      [AIServiceType.OpenAI]: [
        {
          name: THESIS_MODEL_NAME,
          raw: { id: THESIS_MODEL_NAME },
          connectionId: THESIS_CONN_ID,
        },
      ],
    },
  }))
}

/** 登录/登出后把 JWT 写进代付连接 */
export function syncThesisAuthToConnection(token?: string) {
  if (!thesisApiBase()) return
  ensureThesisPlatformConnection(token ?? tokenFromStorage())
}
